<template>
    <div id="firstcharge">
        <router-link to="/">返回首页</router-link>
        <img src="./../../assets/images/yearq.png" alt="">
        <div class="info">
            <h3>首充大优惠</h3>
            <h4>充值9.9得990书币再送1000书豆</h4>
            <p>尊敬的读者您好，给您一次优惠充值，只充9.9元，得990阅读币，再送您1000阅读豆！（机会只有一次哦）</p>

            <button @click="doRecharge">立即充值</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Firstcharge",
        methods : {
            doRecharge(){
                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/firstCharge').then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        }
    }
</script>

<style lang="less">
    #firstcharge{height : 100%;min-height:1300px;overflow:auto;background: url("./../../assets/images/yearbg.png");background-size: 100% 100%;
        img{width: 100%;margin-top: 150px;}
        a{text-indent: 40px;line-height:60px;color: #fff;}
        .info{background: #fff;width: 560px;height:600px;margin: -130px auto 0;border-radius: 40px;padding: 100px 40px;text-align: center;
            h3{color:orangered;font-size: 46px;}
            h4{color: orangered;font-size: 30px;line-height: 60px;padding-top: 30px;}
            p{text-align: left;font-size: 28px;color: #666;line-height: 40px;}
            button{background: orange;width: 100%;border:none;border-radius: 70px;height: 70px;color: #fff;font-size: 40px;margin-top: 40px;}
        }



    }
</style>
